import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
}
const FooterLinkAndCopyrightTextColor="#FFFFFF";
const FooterLinkAndCopyrightTextHoverColor= "#C9E6EE";
const SocialIconColor= "#55A9CB";
const SocialIconHoverColor="#C9E6EE";

export const footerStyles: FooterStyles = {
    page: {
        css: css`      
        .as-footer-nav{
            h4{
                font-size: 16px !important;
                font-weight: 600 !important;
                letter-spacing: 0.05em !important;
            }
        }

        a {
            background: unset;
            border: unset;
            cursor: unset;
            display: unset;
            display: unset;
            display: -ms-flexbox;
            display: unset;
            -webkit-align-items: unset;
            -webkit-box-align: unset;
            -ms-flex-align: unset;
            align-items: unset;
            font: unset;
            padding: unset;
            text-align: unset;
            -webkit-text-decoration: unset;
            text-decoration: unset;
        }
        a {
            background-color: transparent;
            color: #253746;
            transition: color .35s cubic-bezier(.3,.86,.36,.95);
            -webkit-text-decoration: none;
            text-decoration: none;
            &:hover {
                -webkit-text-decoration: none;
                text-decoration: none;
                color: #c8102e;
            }
            span {
                background: unset!important;
                border-radius: unset!important;
                color: unset!important;
                font-weight: unset!important;
            }
        }
        img {
            border-style: none;
        }
        * {
            box-sizing: inherit;
        }
        &:after {
            box-sizing: inherit;
        }
        &:before {
            box-sizing: inherit;
        }
        p {
            margin: 0 0 22px;
        }
        ul {
            margin: 0 0 22px;
        }
        h4 {
            color: #013d54;
            font-weight: inherit;
            margin: 0 0 10px;
        }
        .as-container {
            &:after {
                clear: both;
                content: "";
                display: block;
            }
            margin: 0 auto;
            max-width: 1180px;
            padding-left: 20px;
            padding-right: 20px;
            width: 100%;
        }
            background-color: #55A9CB;
            background-image: linear-gradient(to right, #55A9CB, #042359);
            color: #fff;
            font-size: 18px;
            line-height: 1.2;
            padding: 50px 18px;
            .as-container {
                max-width: 1234px;
            }
        .as-footer-nav-wrap {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -20px 10px;
        }
        .as-footer-area {
            margin: 0 auto;
            max-width: 290px;
            padding: 22px 20px 43px;
            width: 100%;
            .as-btn {
                display: block;
                margin-bottom: 26px;
                padding-left: 5px;
                padding-right: 5px;
                text-align: center;
                &:hover {
                    
                }
            }
            button{
                margin-left: 10px;
            }
        }
        .as-footer-nav {
            padding: 0 20px 17px;
            width: 100%;
            .as-opener {
                color: ${FooterLinkAndCopyrightTextColor};
                display: block;
                position: relative;
                &:after {
                    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17.712' height='10.102'%3E%3Cg data-name='%C3%90%C2%A1%C3%90%C2%B3%C3%91%E2%82%AC%C3%91%C6%92%C3%90%C2%BF%C3%90%C2%BF%C3%90%C2%B8%C3%91%E2%82%AC%C3%90%C2%BE%C3%90%C2%B2%C3%90%C2%B0%C3%91%E2%80%9A%C3%91%C5%92 339'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-width='2' d='m16.298 1.414-7.6 7.288-7.284-7.288' data-name='%C3%90%C5%A1%C3%90%C2%BE%C3%90%C2%BD%C3%91%E2%80%9A%C3%91%C6%92%C3%91%E2%82%AC 14'/%3E%3C/g%3E%3C/svg%3E");
                    background-size: 100% 100%;
                    content: "";
                    height: 10px;
                    position: absolute;
                    right: 0;
                    top: 11px;
                    transition: transform .3s ease;
                    width: 17px;
                }
                &:hover{
                    color: ${FooterLinkAndCopyrightTextHoverColor};
                }
            }
            h4 {
                font-size: 23px;
                font-weight: 700;
                margin: 0 0 8px;
            }
        }
        .as-nav-slide {
            list-style: none;
            margin: 0;
            padding: 18px 0 0;
            li {
                margin-bottom: 13px;
            }
            a {
                color: #fff;
                transition: color .3s ease;
                cursor: pointer;
                &:hover {
                    color: #C9E6EE;
                }
                span{
                    color: unset;
                    &:hover {
                        color: unset;
                    }
                }
            }
        }
        .as-logo-footer {
            margin: 0 0 21px;
            img {
                vertical-align: top;
                width: 100%;
            }
        }
        .as-social-networks {
            display: flex;
            justify-content: space-between;
            list-style: none;
            margin: 0 -1px;
            margin-top: 20px;
            padding: 0;
            li {
                margin: 0 5px;
            }
            a {
                align-items: center;
                display: flex;
                height: 30px;
                justify-content: center;
                transition: opacity .3s ease;
                width: 30px;
                &:hover {
                    cursor:pointer;
                    path {
                        fill: #9adbe8;
                        fill: ${SocialIconHoverColor};
                    }
                    svg {
                        fill: #9adbe8;
                        fill: ${SocialIconHoverColor};
                    }
                }
                svg {
                    max-height: 100%;
                    max-width: 100%;
                    transition: fill .3s ease;
                    vertical-align: top;
                    fill: ${SocialIconColor};
                }
                path {
                    transition: fill .3s ease;
                    fill: ${SocialIconColor};
                }
            }
            button{
                svg {
                    fill: ${SocialIconColor};
                }
                path {
                    fill: ${SocialIconColor};
                }
                &:hover {
                    path {
                        fill: ${SocialIconHoverColor};
                    }
                    svg {
                        fill: ${SocialIconHoverColor};
                    }
                }
            }
        }
        .as-copy {
            color: ${FooterLinkAndCopyrightTextColor}
            font-size: 10px;
            letter-spacing: .13px;
            text-align: center;
            p {
                margin: 0;
            }
        }
        .as-btn {
            color: #fff;
            display: inline-block;
            font-size: 16px;
            letter-spacing: .48px;
            line-height: 1.2;
            padding: 13px 23px;
            transition: background .3s ease,color .3s ease;
            vertical-align: top;
        }
        a.as-btn{
            cursor: pointer;
        }
        .as-btn-primary {
            background: #c8102e;
            border-radius: 10px;
            color: #fff;
            font-weight: 700;
            &:hover {
                background: #253746;
                color: #fff;
            }
            span {
                background: unset!important;
                border-radius: unset!important;
                color: unset!important;
                font-weight: unset!important;
            }
        }
        @media (min-width:768px) {
                font-size: 16px;
                padding: 60px 0 31px;
            .as-footer-area {
                margin: 0;
                padding: 0 20px 40px;
                width: 50%;
                .as-btn {
                    margin-bottom: 51px;
                }
            }
            .as-footer-nav {
                padding: 0 20px 40px;
                width: 50%;
                .as-opener {
                    &:after {
                        display: none;
                    }
                }
                h4 {
                    font-size: 16px;
                    margin: 0 0 24px;
                    color: ${FooterLinkAndCopyrightTextColor};
                    cursor: default;
                    &:hover{
                        
                    }
                    a {
                        pointer-events: none;
                        
                    }
                }
            }
            .as-nav-slide {
                padding: 0;
                li {
                    margin-bottom: 18px;
                }
            }
            .as-logo-footer {
                margin: 0 0 20px;
            }
            .as-social-networks {
                margin: 0 -7px;
                margin-top: 20px;
            }
            .as-copy {
                font-size: 13px;
                text-align: left;
            }
            .as-container{
                max-width: 1310px;
            }
            .as-footer-area{
                button{
                    margin-left: 0px;
                }
            }
        }
        @media (min-width:1024px) {
            .as-footer-nav-wrap {
                flex-wrap: nowrap;
                margin: 0 -20px 7px;
            }
            .as-footer-area {
                margin: 0 10px 0 auto;
                min-width: 250px;
                padding: 4px 0 0;
                width: 250px;
            }
            .as-footer-nav {
                width: 20%;
            }
            .as-footer-nav.as-footer-contact {
                ul {
                    margin-right: -90px;
                }
            }
        }
        @media (min-width:1140px) {
            .as-footer-nav {
                width: 23.8%;
            }
        }
        @media (min-width:1366px) {
            .as-copy {
                margin: 0 0px;
            }
        }
        `
    }
};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <Page as="footer" isFooter={true} {...styles.page}>
        <Zone contentId={id} zoneName="Content" />
        <CookiePrivacyPolicyPopup />
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant. Comment added for deployment.
 */
export const FooterContext = "Footer";
